var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "goodsTable" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          model: {
            value: _vm.goodsInfoActiveTab,
            callback: function ($$v) {
              _vm.goodsInfoActiveTab = $$v
            },
            expression: "goodsInfoActiveTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("OrdinaryOrderMix.GoodsInfoTab.Summarize"),
                name: "sku",
              },
            },
            [
              _vm.goodsInfoActiveTabHistory.has("sku")
                ? _c("SkuList", {
                    ref: "SkuList",
                    attrs: {
                      "order-id": _vm.orderId,
                      "has-btn": _vm.hasBtn,
                      "business-type": _vm.businessType,
                    },
                    on: { afterFetchOriginalData: _vm.afterFetchOriginalData },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("OrdinaryOrderMix.GoodsInfoTab.product"),
                name: "skuItem",
              },
            },
            [
              _vm.goodsInfoActiveTabHistory.has("skuItem")
                ? _c("SkuLineList", {
                    ref: "SkuLineList",
                    attrs: {
                      "order-id": _vm.orderId,
                      "has-btn": _vm.hasBtn,
                      "business-type": _vm.businessType,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          this.$store.state.user.permissionBtns.includes(
            "BusinessGoodsPackageManagement".toLocaleLowerCase()
          )
            ? _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("goodsPage.package.Info"),
                    name: "package",
                  },
                },
                [
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.PackageVOList,
                        border: true,
                        "header-cell-style": _vm.$rowStyle.DEFAULT,
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          label: _vm.$t("table.countText"),
                          type: "index",
                          width: "55",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "packingMethod",
                          label: _vm.$t("goodsPage.packingM"),
                          "show-overflow-tooltip": "",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        _vm.PACKAGE_TYPE_LIST.bjGet(
                                          scope.row.packingMethod
                                        )
                                      )
                                    )
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1552549243
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "name",
                          label: _vm.$t("goodsPage.package.Name"),
                          "show-overflow-tooltip": "",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "sku",
                          label: _vm.$t("goodsPage.package.SKU"),
                          "show-overflow-tooltip": "",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "qty",
                          label: _vm.$t("goodsPage.package.num"),
                          "show-overflow-tooltip": "",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [_vm._v(_vm._s(scope.row.qty))]
                              },
                            },
                          ],
                          null,
                          false,
                          505384257
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "materialFee",
                          label: _vm.$t("goodsPage.package.money1"),
                          "show-overflow-tooltip": "",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    _vm._s(scope.row.materialFee.toFixed(2))
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2723841729
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "labourFee",
                          label: _vm.$t("goodsPage.package.money2"),
                          "show-overflow-tooltip": "",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _vm._v(
                                    _vm._s(scope.row.labourFee.toFixed(2))
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3041231469
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }